export default {
	VIEW_MORE: 'Click to view more',
};
